import axios from "axios";
import * as companyTypes from "../../types/admin/companyTypes";
import { SHARED_LOGIN_SUCCESS } from "../../types/shared/authTypes";

//Create Company
export const createCompanyAction =
  (selectedFile, formingData) => async (dispatch, getState) => {
    try {
      // console.log({ formingData });
      dispatch({
        type: companyTypes.ADMIN_CREATE_COMPANY_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      // const sharedUserInfo = JSON.parse(localStorage.getItem("sharedUserInfo"));
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };

      const formData = new FormData();
      formData.append("logo", selectedFile);
      formData.append("companyName", formingData.companyName);
      formData.append("industry", formingData.industry);
      formData.append("employeeNumber", formingData.employeeNumber);
      formData.append("country", formingData.country);
      formData.append("description", formingData.about);
      formData.append("url", formingData.website);
      formData.append("location", formingData.address);
      formData.append("timeZone", formingData.timeZone);
      formData.append("currency", formingData.currency);

      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/company/register`,
        formData,
        config
      );
      let payload = { ...sharedUserInfo.payload, company: data?.data };

      localStorage.setItem(
        "sharedUserInfo",
        JSON.stringify({ payload }, null, " ")
      );
      dispatch({
        type: SHARED_LOGIN_SUCCESS,
        payload: { payload },
      });
      dispatch({
        type: companyTypes.ADMIN_CREATE_COMPANY_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: companyTypes.ADMIN_CREATE_COMPANY_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

// export const addModulesInCompanyAction =
//   (modules) => async (dispatch, getState) => {
//     try {
//       // console.log({ formingData });
//       dispatch({
//         type: ADMIN_ADD_MODULES_IN_COMPANY_REQUEST,
//       });
//       const {
//         sharedLogin: { sharedUserInfo },
//       } = getState();
//       // const sharedUserInfo = JSON.parse(localStorage.getItem("sharedUserInfo"));
//       const config = {
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `${sharedUserInfo?.payload?.token}`,
//         },
//       };
//       const body = {
//         modulesArr: modules,
//       };
//       let companyId;
//       if (sharedUserInfo?.payload?.company) {
//         companyId = sharedUserInfo?.payload?.company?._id;
//       } else {
//         companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
//       }
//       const { data } = await axios.post(
//         `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/company/add/modules`,
//         body,
//         config
//       );

//       let payload = { company: data.data };

//       localStorage.setItem(
//         "sharedUserInfo",
//         JSON.stringify({ payload }, null, " ")
//       );
//       dispatch({
//         type: SHARED_LOGIN_SUCCESS,
//         payload: { payload },
//       });
//       dispatch({
//         type: ADMIN_ADD_MODULES_IN_COMPANY_SUCCESS,
//         payload: data?.data,
//       });
//     } catch (error) {
//       let err =
//         error.response &&
//         (typeof error.response.data === "string"
//           ? error.response.data
//           : error.response.data.message
//           ? error.response.data.message
//           : error.response.data.errors
//           ? error.response.data.errors[0].msg
//           : error.message);
//       if (!err) {
//         err = "Network Error";
//       }
//       //  console.log(err);
//       dispatch({
//         type: ADMIN_ADD_MODULES_IN_COMPANY_FAIL,
//         payload: err,
//       });
//       throw Error(err);
//     }
//   };

export const activeSubscriptionAction =
  (subsData) => async (dispatch, getState) => {
    try {
      dispatch({
        type: companyTypes.ADMIN_ACTIVE_SUBSCRIPTION_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload.token}`,
        },
      };
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/subscription`,
        subsData,
        config
      );
      // console.log(data.data);
      let payload = {
        ...sharedUserInfo.payload,
        planSub: data.data?._id,
      };
      localStorage.setItem(
        "sharedUserInfo",
        JSON.stringify({ payload }, null, " ")
      );
      dispatch({
        type: SHARED_LOGIN_SUCCESS,
        payload: { payload },
      });
      dispatch({
        type: companyTypes.ADMIN_ACTIVE_SUBSCRIPTION_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: companyTypes.ADMIN_ACTIVE_SUBSCRIPTION_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

export const trailSubscriptionAction =
  (subsData, token) => async (dispatch, getState) => {
    try {
      dispatch({
        type: companyTypes.ADMIN_TRAIL_SUBSCRIPTION_REQUEST,
      });
      // console.log({ subsData });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      // console.log(sharedUserInfo);
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };

      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/trail/`,
        subsData,
        config
      );
      console.log({ data: data?.data });
      let payload = {
        ...sharedUserInfo.payload,
        planSub: data?.data,
      };
      localStorage.setItem(
        "sharedUserInfo",
        JSON.stringify({ payload }, null, " ")
      );
      dispatch({
        type: SHARED_LOGIN_SUCCESS,
        payload: { payload },
      });
      dispatch({
        type: companyTypes.ADMIN_TRAIL_SUBSCRIPTION_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: companyTypes.ADMIN_TRAIL_SUBSCRIPTION_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//Department List
export const departListAction = () => async (dispatch, getState) => {
  // const sharedUserInfo = JSON.parse(localStorage.getItem("sharedUserInfo"));
  try {
    dispatch({
      type: companyTypes.ADMIN_DEPARTMENT_LIST_REQUEST,
    });
    const {
      sharedLogin: { sharedUserInfo },
    } = getState();
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `${sharedUserInfo?.payload?.token}`,
      },
    };
    let companyId;
    if (sharedUserInfo?.payload?.company) {
      companyId = sharedUserInfo?.payload?.company?._id;
    } else if (sharedUserInfo?.empCompanies.length > 0) {
      companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
    }
    const { data } = await axios.get(
      `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/department`,
      config
    );
    // console.log(data);
    dispatch({
      type: companyTypes.ADMIN_DEPARTMENT_LIST_SUCCESS,
      payload: data?.data,
    });
  } catch (error) {
    let err =
      error.response &&
      (typeof error.response.data === "string"
        ? error.response.data
        : error.response.data.message
        ? error.response.data.message
        : error.response.data.errors
        ? error.response.data.errors[0].msg
        : error.message);
    if (!err) {
      err = "Network Error";
    }
    //  console.log(err);
    dispatch({
      type: companyTypes.ADMIN_DEPARTMENT_LIST_FAIL,
      payload: err,
    });
    throw Error(err);
  }
};

//Department List
export const getDepartListAction = (departId) => async (dispatch, getState) => {
  try {
    dispatch({
      type: companyTypes.ADMIN_GET_USER_FROM_DEPART_LIST_REQUEST,
    });
    const {
      sharedLogin: { sharedUserInfo },
    } = getState();
    const config = {
      headers: {
        Authorization: `${sharedUserInfo?.payload?.token}`,
        "Content-Type": "application/json",
      },
    };
    let companyId;
    if (sharedUserInfo?.payload?.company) {
      companyId = sharedUserInfo?.payload?.company?._id;
    } else if (sharedUserInfo?.empCompanies.length > 0) {
      companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
    }
    const { data } = await axios.get(
      `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/department/employees/${departId}`,
      config
    );
    // console.log({ data });
    dispatch({
      type: companyTypes.ADMIN_GET_USER_FROM_DEPART_LIST_SUCCESS,
      payload: data?.data,
    });
  } catch (error) {
    let err =
      error.response &&
      (typeof error.response.data === "string"
        ? error.response.data
        : error.response.data.message
        ? error.response.data.message
        : error.response.data.errors
        ? error.response.data.errors[0].msg
        : error.message);
    if (!err) {
      err = "Network Error";
    }
    //  console.log(err);
    dispatch({
      type: companyTypes.ADMIN_GET_USER_FROM_DEPART_LIST_FAIL,
      payload: err,
    });
    throw Error(err);
  }
};

//Department List
export const departAddAction = (depart) => async (dispatch, getState) => {
  try {
    dispatch({
      type: companyTypes.ADMIN_ADD_DEPARTMENT_LIST_REQUEST,
    });
    const {
      sharedLogin: { sharedUserInfo },
    } = getState();
    const config = {
      headers: {
        Authorization: `${sharedUserInfo?.payload?.token}`,
        "Content-Type": "application/json",
      },
    };
    const body = {
      departmentName: depart,
    };
    let companyId;
    if (sharedUserInfo?.payload?.company) {
      companyId = sharedUserInfo?.payload?.company?._id;
    } else if (sharedUserInfo?.empCompanies.length > 0) {
      companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
    }
    const { data } = await axios.post(
      `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/department`,
      body,
      config
    );
    dispatch({
      type: companyTypes.ADMIN_ADD_DEPARTMENT_LIST_SUCCESS,
      payload: data?.data,
    });
  } catch (error) {
    let err =
      error.response &&
      (typeof error.response.data === "string"
        ? error.response.data
        : error.response.data.message
        ? error.response.data.message
        : error.response.data.errors
        ? error.response.data.errors[0].msg
        : error.message);
    if (!err) {
      err = "Network Error";
    }
    //  console.log(err);
    dispatch({
      type: companyTypes.ADMIN_ADD_DEPARTMENT_LIST_FAIL,
      payload: err,
    });
    throw Error(err);
  }
};

export const addUserInDepartAction =
  (selectDepart, userId) => async (dispatch, getState) => {
    try {
      dispatch({
        type: companyTypes.ADMIN_ADD_USER_IN_DEPARTMENT_LIST_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      const config = {
        headers: {
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const data = await axios.put(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/department/${selectDepart}/${userId}/`,
        {},
        config
      );
      // console.log(data?.data);
      dispatch({
        type: companyTypes.ADMIN_ADD_USER_IN_DEPARTMENT_LIST_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: companyTypes.ADMIN_ADD_USER_IN_DEPARTMENT_LIST_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

export const editDepartAction =
  (departId, departmentName) => async (dispatch, getState) => {
    try {
      dispatch({
        type: companyTypes.ADMIN_UPDATE_DEPARTMENT_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      const config = {
        headers: {
          Authorization: `${sharedUserInfo?.payload?.token}`,
          "Content-Type": "application/json",
        },
      };
      const body = {
        departmentName: departmentName,
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const data = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/department/${departId}`,
        body,
        config
      );
      // console.log(data?.data);
      dispatch({
        type: companyTypes.ADMIN_UPDATE_DEPARTMENT_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: companyTypes.ADMIN_UPDATE_DEPARTMENT_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//Invite Email
export const inviteEmailAction = (email) => async (dispatch, getState) => {
  // const sharedUserInfo = JSON.parse(localStorage.getItem("sharedUserInfo"));
  try {
    dispatch({
      type: companyTypes.ADMIN_INVITE_BY_EMAIL_REQUEST,
    });
    const {
      sharedLogin: { sharedUserInfo },
    } = getState();
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `${sharedUserInfo?.payload?.token}`,
      },
    };
    const body = {
      email: email,
    };
    let companyId;
    if (sharedUserInfo?.payload?.company) {
      companyId = sharedUserInfo?.payload?.company?._id;
    } else if (sharedUserInfo?.empCompanies.length > 0) {
      companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
    }
    const { data } = await axios.post(
      `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/employees/invite/email`,
      body,
      config
    );
    // console.log(data);
    dispatch({
      type: companyTypes.ADMIN_INVITE_BY_EMAIL_SUCCESS,
      payload: data?.data,
    });
  } catch (error) {
    let err =
      error.response &&
      (typeof error.response.data === "string"
        ? error.response.data
        : error.response.data.message
        ? error.response.data.message
        : error.response.data.errors
        ? error.response.data.errors[0].msg
        : error.message);
    if (!err) {
      err = "Network Error";
    }
    //  console.log(err);
    dispatch({
      type: companyTypes.ADMIN_INVITE_BY_EMAIL_FAIL,
      payload: err,
    });
    throw Error(err);
  }
};
//Delete Department
export const deleteDepartmentAction =
  (departId) => async (dispatch, getState) => {
    // const sharedUserInfo = JSON.parse(localStorage.getItem("sharedUserInfo"));
    try {
      dispatch({
        type: companyTypes.ADMIN_DELETE_DEPARTMENT_LIST_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      const config = {
        headers: {
          Authorization: `${sharedUserInfo?.payload.token}`,
        },
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.delete(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/department/employees/${departId}/delete`,
        config
      );
      dispatch({
        type: companyTypes.ADMIN_DELETE_DEPARTMENT_LIST_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: companyTypes.ADMIN_DELETE_DEPARTMENT_LIST_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

export const addGoalsAction = (formData) => async (dispatch, getState) => {
  // const sharedUserInfo = JSON.parse(localStorage.getItem("sharedUserInfo"));
  try {
    dispatch({
      type: companyTypes.ADMIN_ADD_GOALS_REQUEST,
    });
    const {
      sharedLogin: { sharedUserInfo },
    } = getState();
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `${sharedUserInfo?.payload?.token}`,
      },
    };
    let body = {
      userGoal: formData,
    };
    let companyId;
    if (sharedUserInfo?.payload?.company) {
      companyId = sharedUserInfo?.payload?.company?._id;
    } else if (sharedUserInfo?.empCompanies.length > 0) {
      companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
    }
    const { data } = await axios.post(
      `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/goal/${sharedUserInfo?.payload?.id}`,
      body,
      config
    );
    dispatch({
      type: companyTypes.ADMIN_ADD_GOALS_SUCCESS,
      payload: data?.data,
    });
  } catch (error) {
    let err =
      error.response &&
      (typeof error.response.data === "string"
        ? error.response.data
        : error.response.data.message
        ? error.response.data.message
        : error.response.data.errors
        ? error.response.data.errors[0].msg
        : error.message);
    if (!err) {
      err = "Network Error";
    }
    //  console.log(err);
    dispatch({
      type: companyTypes.ADMIN_ADD_GOALS_FAIL,
      payload: err,
    });
    throw Error(err);
  }
};

export const updateCompanyDetailAction =
  (formData) => async (dispatch, getState) => {
    // const sharedUserInfo = JSON.parse(localStorage.getItem("sharedUserInfo"));
    // console.log({ formData });
    try {
      dispatch({
        type: companyTypes.ADMIN_UPDATE_COMPANY_DETAIL_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      console.log({ formData });
      let body = {
        companyName: formData.companyName,
        industry: formData.industry,
        address: formData.address,
        companyId: companyId,
        website: formData.website,
        linkedIn: formData.linkedIn,
        about: formData.about,
      };
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/company/update`,
        body,
        config
      );
      dispatch({
        type: companyTypes.ADMIN_UPDATE_COMPANY_DETAIL_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: companyTypes.ADMIN_UPDATE_COMPANY_DETAIL_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//ChangedImage
export const adminChangedOrgLogoAction =
  (selectedFile) => async (dispatch, getState) => {
    try {
      dispatch({
        type: companyTypes.ADMIN_UPDATE_COMPANY_LOGO_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      const config = {
        headers: {
          Authorization: `${sharedUserInfo?.payload.token}`,
        },
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const formData = new FormData();

      formData.append("logo", selectedFile);
      formData.append("companyId", companyId);

      // console.log(formData);
      const { data } = await axios.put(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/company/updateorg/${sharedUserInfo?.payload?.id}`,
        formData,
        config
      );
      // console.log(data);
      dispatch({
        type: companyTypes.ADMIN_UPDATE_COMPANY_LOGO_SUCCESS,
        payload: data?.data,
      });
      localStorage.setItem(
        "sharedUserInfo",
        JSON.stringify(data?.data, null, " ")
      );
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      // //  console.log(err);
      dispatch({
        type: companyTypes.ADMIN_UPDATE_COMPANY_LOGO_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

export const addCompanyModulesAction =
  (modules) => async (dispatch, getState) => {
    try {
      dispatch({
        type: companyTypes.ADMIN_ADD_COMPANY_MODULES_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      const config = {
        headers: {
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const data = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/company/add/modules`,
        { modulesArr: modules },
        config
      );
      // console.log({ sharedUserInfo });
      // console.log({ data });
      localStorage.setItem(
        "sharedUserInfo",
        JSON.stringify(data?.data?.data, null, " ")
      );
      dispatch({
        type: SHARED_LOGIN_SUCCESS,
        payload: data?.data?.data,
      });

      dispatch({
        type: companyTypes.ADMIN_ADD_COMPANY_MODULES_SUCCESS,
        payload: data?.data,
      });
      return data?.data;
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: companyTypes.ADMIN_ADD_COMPANY_MODULES_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

export const addJobBoardLinkAction = (body) => async (dispatch, getState) => {
  try {
    dispatch({
      type: companyTypes.ADD_JOB_BOARD_LINK_REQUEST,
    });
    const {
      sharedLogin: { sharedUserInfo },
    } = getState();
    const config = {
      headers: {
        Authorization: `${sharedUserInfo?.payload?.token}`,
      },
    };
    let companyId;
    if (sharedUserInfo?.payload?.company) {
      companyId = sharedUserInfo?.payload?.company?._id;
    } else if (sharedUserInfo?.empCompanies.length > 0) {
      companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
    }
    const data = await axios.post(
      `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/setting/uniqueIdentifier/update`,
      body,
      config
    );
    // console.log(data?.data);
    dispatch({
      type: companyTypes.ADD_JOB_BOARD_LINK_SUCCESS,
      payload: data?.data,
    });
  } catch (error) {
    let err =
      error.response &&
      (typeof error.response.data === "string"
        ? error.response.data
        : error.response.data.message
        ? error.response.data.message
        : error.response.data.errors
        ? error.response.data.errors[0].msg
        : error.message);
    if (!err) {
      err = "Network Error";
    }
    //  console.log(err);
    dispatch({
      type: companyTypes.ADD_JOB_BOARD_LINK_FAIL,
      payload: err,
    });
    throw Error(err);
  }
};

export const getJobBoardLinkAction = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: companyTypes.GET_JOB_BOARD_LINK_REQUEST,
    });
    const {
      sharedLogin: { sharedUserInfo },
    } = getState();
    const config = {
      headers: {
        Authorization: `${sharedUserInfo?.payload?.token}`,
      },
    };
    let companyId;
    if (sharedUserInfo?.payload?.company) {
      companyId = sharedUserInfo?.payload?.company?._id;
    } else if (sharedUserInfo?.empCompanies.length > 0) {
      companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
    }
    const data = await axios.get(
      `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}`,
      config
    );
    // console.log(data?.data);
    dispatch({
      type: companyTypes.GET_JOB_BOARD_LINK_SUCCESS,
      payload: data?.data,
    });
  } catch (error) {
    let err =
      error.response &&
      (typeof error.response.data === "string"
        ? error.response.data
        : error.response.data.message
        ? error.response.data.message
        : error.response.data.errors
        ? error.response.data.errors[0].msg
        : error.message);
    if (!err) {
      err = "Network Error";
    }
    //  console.log(err);
    dispatch({
      type: companyTypes.GET_JOB_BOARD_LINK_FAIL,
      payload: err,
    });
    throw Error(err);
  }
};

//leaveCategoryImport
export const leaveCategoryImportAction =
  (formdata) => async (dispatch, getState) => {
    try {
      dispatch({
        type: companyTypes.LEAVE_CATEGORY_IMPORT_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };

      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      // const formdata = new FormData();
      // formdata.append("csfile", file);
      // formdata.append("csExtension", extension);
      // console.log(formData);
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/bulk-leave-qouta/update-create`,
        formdata,
        config
      );
      // console.log(data);
      dispatch({
        type: companyTypes.LEAVE_CATEGORY_IMPORT_SUCCESS,
        payload: data?.data,
      });
      return data;
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      // //  console.log(err);
      dispatch({
        type: companyTypes.LEAVE_CATEGORY_IMPORT_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//userQuotaImport
export const userQuotaImportAction =
  (formdata) => async (dispatch, getState) => {
    try {
      dispatch({
        type: companyTypes.USER_QUOTA_IMPORT_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };

      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      // const formdata = new FormData();
      // formdata.append("csfile", file);
      // formdata.append("csExtension", extension);
      // console.log(formData);
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/bulk-leave-qouta/user-update-create`,
        formdata,
        config
      );
      // console.log(data);
      dispatch({
        type: companyTypes.USER_QUOTA_IMPORT_SUCCESS,
        payload: data?.data,
      });
      return data;
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      // //  console.log(err);
      dispatch({
        type: companyTypes.USER_QUOTA_IMPORT_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//userQuotaImport
export const advancedUserQuotaImportAction =
  (formdata) => async (dispatch, getState) => {
    try {
      dispatch({
        type: companyTypes.ADVANCED_USER_QUOTA_IMPORT_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };

      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      // const formdata = new FormData();
      // formdata.append("csfile", file);
      // formdata.append("csExtension", extension);
      // console.log(formData);
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/bulk-leave-qouta/update-create`,
        formdata,
        config
      );
      // console.log(data);
      dispatch({
        type: companyTypes.ADVANCED_USER_QUOTA_IMPORT_SUCCESS,
        payload: data?.data,
      });
      return data;
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      // //  console.log(err);
      dispatch({
        type: companyTypes.ADVANCED_USER_QUOTA_IMPORT_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//shiftImport
export const shiftImportAction = (formdata) => async (dispatch, getState) => {
  try {
    dispatch({
      type: companyTypes.SHIFT_IMPORT_REQUEST,
    });
    const {
      sharedLogin: { sharedUserInfo },
    } = getState();
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `${sharedUserInfo?.payload?.token}`,
      },
    };

    let companyId;
    if (sharedUserInfo?.payload?.company) {
      companyId = sharedUserInfo?.payload?.company?._id;
    } else if (sharedUserInfo?.empCompanies.length > 0) {
      companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
    }
    // const formdata = new FormData();
    // formdata.append("csfile", file);
    // formdata.append("csExtension", extension);
    // console.log(formData);
    const { data } = await axios.post(
      `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/bulk-shift-temp/update-create`,
      formdata,
      config
    );
    // console.log(data);
    dispatch({
      type: companyTypes.SHIFT_IMPORT_SUCCESS,
      payload: data?.data,
    });
    return data;
  } catch (error) {
    let err =
      error.response &&
      (typeof error.response.data === "string"
        ? error.response.data
        : error.response.data.message
        ? error.response.data.message
        : error.response.data.errors
        ? error.response.data.errors[0].msg
        : error.message);
    if (!err) {
      err = "Network Error";
    }
    // //  console.log(err);
    dispatch({
      type: companyTypes.SHIFT_IMPORT_FAIL,
      payload: err,
    });
    throw Error(err);
  }
};

// //userQuotaImport
// export const advancedUserQuotaImportAction =
//   (formdata) => async (dispatch, getState) => {
//     try {
//       dispatch({
//         type: companyTypes.ADVANCED_USER_QUOTA_IMPORT_REQUEST,
//       });
//       const {
//         sharedLogin: { sharedUserInfo },
//       } = getState();
//       const config = {
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `${sharedUserInfo?.payload?.token}`,
//         },
//       };

//       let companyId;
//       if (sharedUserInfo?.payload?.company) {
//         companyId = sharedUserInfo?.payload?.company?._id;
//       } else if (sharedUserInfo?.empCompanies.length > 0) {
//         companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
//       }
//       // const formdata = new FormData();
//       // formdata.append("csfile", file);
//       // formdata.append("csExtension", extension);
//       // console.log(formData);
//       const { data } = await axios.post(
//         `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/bulk-leave-qouta/update-create`,
//         formdata,
//         config
//       );
//       // console.log(data);
//       dispatch({
//         type: companyTypes.ADVANCED_USER_QUOTA_IMPORT_SUCCESS,
//         payload: data?.data,
//       });
//       return data;
//     } catch (error) {
//       let err =
//         error.response &&
//         (typeof error.response.data === "string"
//           ? error.response.data
//           : error.response.data.message
//           ? error.response.data.message
//           : error.response.data.errors
//           ? error.response.data.errors[0].msg
//           : error.message);
//       if (!err) {
//         err = "Network Error";
//       }
//       // //  console.log(err);
//       dispatch({
//         type: companyTypes.ADVANCED_USER_QUOTA_IMPORT_FAIL,
//         payload: err,
//       });
//       throw Error(err);
//     }
//   };

//payrollImport
export const payrollImportAction = (formdata) => async (dispatch, getState) => {
  try {
    dispatch({
      type: companyTypes.PAYROLL_IMPORT_REQUEST,
    });
    const {
      sharedLogin: { sharedUserInfo },
    } = getState();
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `${sharedUserInfo?.payload?.token}`,
      },
    };

    let companyId;
    if (sharedUserInfo?.payload?.company) {
      companyId = sharedUserInfo?.payload?.company?._id;
    } else if (sharedUserInfo?.empCompanies.length > 0) {
      companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
    }
    // const formdata = new FormData();
    // formdata.append("csfile", file);
    // formdata.append("csExtension", extension);
    // console.log(formData);
    const { data } = await axios.post(
      `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/bulk-user-payroll/update-create`,
      formdata,
      config
    );
    // console.log(data);
    dispatch({
      type: companyTypes.PAYROLL_IMPORT_SUCCESS,
      payload: data?.data,
    });
    return data?.data;
  } catch (error) {
    let err =
      error.response &&
      (typeof error.response.data === "string"
        ? error.response.data
        : error.response.data.message
        ? error.response.data.message
        : error.response.data.errors
        ? error.response.data.errors[0].msg
        : error.message);
    if (!err) {
      err = "Network Error";
    }
    // //  console.log(err);
    dispatch({
      type: companyTypes.PAYROLL_IMPORT_FAIL,
      payload: err,
    });
    throw Error(err);
  }
};

export const editTeamAction =
  (departId, formData) => async (dispatch, getState) => {
    try {
      dispatch({
        type: companyTypes.ADMIN_TEAM_UPDATE_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      const config = {
        headers: {
          Authorization: `${sharedUserInfo?.payload?.token}`,
          "Content-Type": "application/json",
        },
      };
      const body = {
        departmentName: formData.departmentName,
        usersArr: formData.usersArr,
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const data = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/department/${departId}/dept-team-update`,
        body,
        config
      );
      // console.log(data?.data);
      dispatch({
        type: companyTypes.ADMIN_TEAM_UPDATE_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: companyTypes.ADMIN_TEAM_UPDATE_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

export const sendHRLetterAction = (formDated) => async (dispatch, getState) => {
  try {
    dispatch({
      type: companyTypes.SEND_HR_LETTER_REQUEST,
    });
    const {
      sharedLogin: { sharedUserInfo },
    } = getState();
    const config = {
      headers: {
        Authorization: `${sharedUserInfo?.payload?.token}`,
        "Content-Type": "application/json",
      },
    };
    let companyId;
    if (sharedUserInfo?.payload?.company) {
      companyId = sharedUserInfo?.payload?.company?._id;
    } else if (sharedUserInfo?.empCompanies.length > 0) {
      companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
    }
    const formData = new FormData();
    if (formDated?.templateId) {
      formData.append("templateId", formDated?.templateId);
    }
    if (formDated?.usersArr) {
      formData.append("usersArrJson", JSON.stringify(formDated?.usersArr));
    }
    if (formDated?.attachment) {
      formData.append("attachment", formDated?.attachment);
    }
    const data = await axios.post(
      `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/manual-email/send`,
      formData,
      config
    );
    // console.log(data?.data);
    dispatch({
      type: companyTypes.SEND_HR_LETTER_SUCCESS,
      payload: data?.data,
    });
  } catch (error) {
    let err =
      error.response &&
      (typeof error.response.data === "string"
        ? error.response.data
        : error.response.data.message
        ? error.response.data.message
        : error.response.data.errors
        ? error.response.data.errors[0].msg
        : error.message);
    if (!err) {
      err = "Network Error";
    }
    //  console.log(err);
    dispatch({
      type: companyTypes.SEND_HR_LETTER_FAIL,
      payload: err,
    });
    throw Error(err);
  }
};

export const getHRLettersAction = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: companyTypes.GET_HR_LETTERS_REQUEST,
    });
    const {
      sharedLogin: { sharedUserInfo },
    } = getState();
    const config = {
      headers: {
        Authorization: `${sharedUserInfo?.payload?.token}`,
        "Content-Type": "application/json",
      },
    };
    let companyId;
    if (sharedUserInfo?.payload?.company) {
      companyId = sharedUserInfo?.payload?.company?._id;
    } else if (sharedUserInfo?.empCompanies.length > 0) {
      companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
    }
    const data = await axios.get(
      `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/manual-email/get-history`,
      config
    );
    // console.log(data?.data);
    dispatch({
      type: companyTypes.GET_HR_LETTERS_SUCCESS,
      payload: data?.data?.data,
    });
  } catch (error) {
    let err =
      error.response &&
      (typeof error.response.data === "string"
        ? error.response.data
        : error.response.data.message
        ? error.response.data.message
        : error.response.data.errors
        ? error.response.data.errors[0].msg
        : error.message);
    if (!err) {
      err = "Network Error";
    }
    //  console.log(err);
    dispatch({
      type: companyTypes.GET_HR_LETTERS_FAIL,
      payload: err,
    });
    throw Error(err);
  }
};

// Get Company Apps
export const getCompanyAppsAction = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: companyTypes.GET_COMPANY_APPS_REQUEST,
    });

    const {
      sharedLogin: { sharedUserInfo },
    } = getState();

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `${sharedUserInfo?.payload?.token}`,
      },
    };

    let companyId;
    if (sharedUserInfo?.payload?.company) {
      companyId = sharedUserInfo?.payload?.company?._id;
    } else if (sharedUserInfo?.empCompanies.length > 0) {
      companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
    }

    const { data } = await axios.get(
      `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/setting/get/company-apps`,
      config
    );

    dispatch({
      type: companyTypes.GET_COMPANY_APPS_SUCCESS,
      payload: data?.data,
    });

    return data?.data;
  } catch (error) {
    let err =
      error.response &&
      (typeof error.response.data === "string"
        ? error.response.data
        : error.response.data.message
        ? error.response.data.message
        : error.response.data.errors
        ? error.response.data.errors[0].msg
        : error.message);
    if (!err) {
      err = "Network Error";
    }
    dispatch({
      type: companyTypes.GET_COMPANY_APPS_FAIL,
      payload: err,
    });
    throw Error(err);
  }
};
//get allowed apps
export const getAllowedAppsAction = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: companyTypes.GET_ALLOWED_APPS_REQUEST,
    });

    const {
      sharedLogin: { sharedUserInfo },
    } = getState();

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `${sharedUserInfo?.payload?.token}`,
      },
    };

    let companyId;
    if (sharedUserInfo?.payload?.company) {
      companyId = sharedUserInfo?.payload?.company?._id;
    } else if (sharedUserInfo?.empCompanies.length > 0) {
      companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
    }

    const { data } = await axios.get(
      `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/setting/get/allowed-apps`,
      config
    );

    dispatch({
      type: companyTypes.GET_ALLOWED_APPS_SUCCESS,
      payload: data?.allowedApps,
    });

    return data?.allowedApps;
  } catch (error) {
    let err =
      error.response &&
      (typeof error.response.data === "string"
        ? error.response.data
        : error.response.data.message
        ? error.response.data.message
        : error.response.data.errors
        ? error.response.data.errors[0].msg
        : error.message);
    if (!err) {
      err = "Network Error";
    }
    dispatch({
      type: companyTypes.GET_ALLOWED_APPS_FAIL,
      payload: err,
    });
    throw Error(err);
  }
};
// Update Company Apps Locally
export const updateCompanyAppsLocal = (appsData) => ({
  type: companyTypes.UPDATE_COMPANY_APPS_LOCAL,
  payload: appsData,
});

// Save Company Apps
export const saveCompanyAppsAction =
  (appsData) => async (dispatch, getState) => {
    try {
      dispatch({
        type: companyTypes.SAVE_COMPANY_APPS_REQUEST,
      });

      const {
        sharedLogin: { sharedUserInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };

      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }

      const { data } = await axios.put(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/setting/save/company-apps`,
        appsData,
        config
      );

      dispatch({
        type: companyTypes.SAVE_COMPANY_APPS_SUCCESS,
        payload: data?.data,
      });

      return data;
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      dispatch({
        type: companyTypes.SAVE_COMPANY_APPS_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };
